import PropTypes from 'prop-types';
import styles from './FJSharedCreations.module.less';
import FJBlankPanel from '../../../../FJMainPreview/FJBlankPanel/FJBlankPanel';
import FJLocalStore from '../../../../../store/FJLocalStore';
import NoContentIcon from '../../../../../assets/svg/no-content.svg?react';
import FJCommunityMixViewList from '../../../FJCommonComponent/FJCommunityMixViewList/FJCommunityMixViewList';
const FJSharedCreations = props => {
    const {
        active,
        sharedCreationsList,
        getMoreSharedCreationsData,
        sharedCreationsPageInfo,
        changeMySpaceTabToCreations,
    } = props;
    const { initLoading, getMoreLoading, hasMore } = sharedCreationsPageInfo;
    const _shareNow = () => {
        changeMySpaceTabToCreations();
    };
    const _renderEmpty = () => {
        return (
            <FJBlankPanel
                icon={<NoContentIcon />}
                text={FJLocalStore._('no-public-creations-yet')}
                textSuffix={<span onClick={_shareNow}>{FJLocalStore._('share-now')}</span>}
            />
        );
    };
    const _renderList = () => {
        return (
            <FJCommunityMixViewList
                className={styles.list}
                list={sharedCreationsList}
                getMoreData={getMoreSharedCreationsData}
                initLoading={initLoading}
                getMoreLoading={getMoreLoading}
                hasMore={hasMore}
                active={active}
            />
        );
    };

    if (!active) return null;
    if (initLoading) {
        return <FJCommunityMixViewList className={styles.list} initLoading={true} hasMore={false} />;
    }
    return sharedCreationsList.length ? _renderList() : _renderEmpty();
};
FJSharedCreations.propTypes = {
    active: PropTypes.bool.isRequired,
    sharedCreationsList: PropTypes.array.isRequired,
    getMoreSharedCreationsData: PropTypes.func.isRequired,
    isMultipleSelect: PropTypes.bool.isRequired,
    multipleSelectedList: PropTypes.array.isRequired,
    sharedCreationsPageInfo: PropTypes.object.isRequired,
    changeMySpaceTabToCreations: PropTypes.func.isRequired,
};
export default FJSharedCreations;
